/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ContactCopyright } from '../models/contact-copyright';
import { ContactCopyrightWithRelations } from '../models/contact-copyright-with-relations';
import { createCopyright } from '../fn/editor-contact-copyright-controller/create-copyright';
import { CreateCopyright$Params } from '../fn/editor-contact-copyright-controller/create-copyright';
import { deleteCopyright } from '../fn/editor-contact-copyright-controller/delete-copyright';
import { DeleteCopyright$Params } from '../fn/editor-contact-copyright-controller/delete-copyright';
import { getCopyrightsByContact } from '../fn/editor-contact-copyright-controller/get-copyrights-by-contact';
import { GetCopyrightsByContact$Params } from '../fn/editor-contact-copyright-controller/get-copyrights-by-contact';
import { updateCopyright } from '../fn/editor-contact-copyright-controller/update-copyright';
import { UpdateCopyright$Params } from '../fn/editor-contact-copyright-controller/update-copyright';

@Injectable({ providedIn: 'root' })
export class EditorContactCopyrightControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `contactCopyrightControllerGetCopyrightsByContact()` */
  static readonly ContactCopyrightControllerGetCopyrightsByContactPath = '/editor/contact-copyrights';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCopyrightsByContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCopyrightsByContact$Response(params: GetCopyrightsByContact$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContactCopyrightWithRelations>>> {
    return getCopyrightsByContact(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCopyrightsByContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCopyrightsByContact(params: GetCopyrightsByContact$Params, context?: HttpContext): Observable<Array<ContactCopyrightWithRelations>> {
    return this.getCopyrightsByContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ContactCopyrightWithRelations>>): Array<ContactCopyrightWithRelations> => r.body)
    );
  }

  /** Path part for operation `contactCopyrightControllerCreateCopyright()` */
  static readonly ContactCopyrightControllerCreateCopyrightPath = '/editor/contact-copyrights';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCopyright()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCopyright$Response(params?: CreateCopyright$Params, context?: HttpContext): Observable<StrictHttpResponse<ContactCopyright>> {
    return createCopyright(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createCopyright$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCopyright(params?: CreateCopyright$Params, context?: HttpContext): Observable<ContactCopyright> {
    return this.createCopyright$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContactCopyright>): ContactCopyright => r.body)
    );
  }

  /** Path part for operation `contactCopyrightControllerDeleteCopyright()` */
  static readonly ContactCopyrightControllerDeleteCopyrightPath = '/editor/contact-copyrights';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCopyright()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCopyright$Response(params: DeleteCopyright$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return deleteCopyright(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCopyright$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCopyright(params: DeleteCopyright$Params, context?: HttpContext): Observable<any> {
    return this.deleteCopyright$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `contactCopyrightControllerUpdateCopyright()` */
  static readonly ContactCopyrightControllerUpdateCopyrightPath = '/editor/contact-copyrights';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCopyright()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCopyright$Response(params: UpdateCopyright$Params, context?: HttpContext): Observable<StrictHttpResponse<ContactCopyright>> {
    return updateCopyright(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCopyright$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCopyright(params: UpdateCopyright$Params, context?: HttpContext): Observable<ContactCopyright> {
    return this.updateCopyright$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContactCopyright>): ContactCopyright => r.body)
    );
  }

}
